// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-container {
    display: flex;
    align-items: center;
}

.slider {
    display: inline-flex;
    overflow: hidden;
    width: 300px;
    white-space: nowrap;
    position: relative;
}

.slider-inner {
    display: flex;
    transition: transform 0.5s ease-in-out; /* Переход на изменение transform */
}

.slider-item {
    flex: 0 0 auto;
    width: 100px;
    height: 100px;
    margin-right: 10px;
    background-color: lightblue;
    display: flex;
    justify-content: center;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/ItemSlider/ItemSlider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sCAAsC,EAAE,mCAAmC;AAC/E;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".slider-container {\n    display: flex;\n    align-items: center;\n}\n\n.slider {\n    display: inline-flex;\n    overflow: hidden;\n    width: 300px;\n    white-space: nowrap;\n    position: relative;\n}\n\n.slider-inner {\n    display: flex;\n    transition: transform 0.5s ease-in-out; /* Переход на изменение transform */\n}\n\n.slider-item {\n    flex: 0 0 auto;\n    width: 100px;\n    height: 100px;\n    margin-right: 10px;\n    background-color: lightblue;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
